import { Grid } from "@mui/material";
import { ExitButton } from "../../components/Custom/Buttons";
import PreviewToggleButtons from "../../components/PreviewToggleButtons";

import {
  BodyHeaderInnerGrid,
  DeviceContainer,
  ExitContainer,
  PreviewBodyHeaderContainer,
} from "./styled";

export default function PreviewBodyHeader({
  handlePreviewClick,
  previewType,
  setPreviewType,
  onExitClick,
  isShareMode = false
}: any) {
  return (
    <PreviewBodyHeaderContainer>
      <BodyHeaderInnerGrid container>
        <Grid item xs={4} />
        <DeviceContainer item xs={4}>
          <PreviewToggleButtons
            previewType={previewType}
            setPreviewType={setPreviewType}
            handlePreviewClick={handlePreviewClick}
            isShareMode={isShareMode}
          />
        </DeviceContainer>
        <ExitContainer item xs={4}>
          {!sessionStorage.getItem("noWorkspace") && (
            <ExitButton onClick={onExitClick} />
          )}
        </ExitContainer>
      </BodyHeaderInnerGrid>
    </PreviewBodyHeaderContainer>
  );
}
